import { useState, useEffect } from "react"
import axios from "axios"

const useHomePage = () => {
  const [homeData, setHomeData] = useState([])
  const [loading, setloading] = useState(true)
  const [error, seterror] = useState("")

  const getHomeData = async () => {
    const url = `${process.env.GATSBY_API_URL}/wp-json/wp/v2/pages/2`

    try {
      const { data } = await axios.get(url)
      setHomeData(data)
      setloading(false)
    } catch (error) {
      console.log(error)
      setloading(false)
      seterror(error)
    }
  }

  useEffect(() => {
    getHomeData()
  }, [])
  return { homeData, loading, error }
}

export default useHomePage
